import iconWhite from "../assets/iconWhite.svg";
import { FaWhatsapp } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";

export default function Footer() {
	const socialLinks = {
		whatsapp: "https://wa.me/+522225548923",
		facebook:
			"https://www.facebook.com/Comercializadora-Central-ENT-100735088917867/",
		instagram: "https://www.instagram.com/comercializadoracentralent/",
		linkedin:
			"https://www.linkedin.com/in/comercializadora-central-ent-925071214/",
	};
	return (
		<footer className="w-full bg-[#0a1633] text-[#cbbca3] py-12 px-6">
			<div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
				<div className="flex flex-col items-center md:items-start gap-4">
					<img
						src={iconWhite}
						alt="footer logo"
						className="w-32 h-auto object-contain"
					/>
				</div>

				<div className="flex flex-col gap-3">
					<h3 className="font-semibold text-lg">Enlaces</h3>
					<ul className="flex flex-col gap-2 text-sm text-[#cbbca3]/80">
						<li>Contacto</li>
						<li>Seguridad</li>
						<li>Términos y condiciones</li>
						<li>Privacidad</li>
					</ul>
				</div>

				<div className=" flex flex-col gap-3">
					<h3 className="font-semibold text-lg">Redes sociales</h3>
					<p className="text-sm text-[#cbbca3]/80">
						Contáctanos en nuestras redes sociales.
					</p>
					<div className=" flex gap-4 text-xl">
						<a
							href={socialLinks.whatsapp}
							target="_blank"
							rel="noreferrer noopener"
							aria-label="Abrir WhatsApp"
						>
							<FaWhatsapp className="hover:text-white transition cursor-pointer" />
						</a>
						<a
							href={socialLinks.facebook}
							target="_blank"
							rel="noreferrer noopener"
							aria-label="Abrir Facebook"
						>
							<FaFacebookF className="hover:text-white transition cursor-pointer" />
						</a>
						<a
							href={socialLinks.instagram}
							target="_blank"
							rel="noreferrer noopener"
							aria-label="Abrir Instagram"
						>
							<FaInstagram className="hover:text-white transition cursor-pointer" />
						</a>
						<a
							href={socialLinks.linkedin}
							target="_blank"
							rel="noreferrer noopener"
							aria-label="Abrir LinkedIn"
						>
							<FaLinkedinIn className="hover:text-white transition cursor-pointer" />
						</a>
					</div>
				</div>

				<div className="flex flex-col gap-3">
					<h3 className="font-semibold text-lg">Información</h3>
					<p className="text-sm text-[#cbbca3]/80 leading-relaxed">
						Horarios de atención: 10:00 AM - 7:00 PM Teléfono: 222 554 8923
						comercializadora.1102@gmail.com 47 Poniente 707 INT. 202 Col. Prados
						Agua Azul, Puebla de Zaragoza, México C.P. 72430
					</p>
				</div>
			</div>
		</footer>
	);
}
